import {DriverLicenseStatusReportBase} from './driverLicenseStatusReport/type'
import {FleetReportBase} from './fleetReport/type'
import {InspectionReportBase} from './inspectionReport/type'
import {StudentAttendanceReportBase} from './studentAttendanceReport/type'
import {RouteReportBase} from './RouteReport/type'
import {DriverLoginReportBase} from './DriverLoginReport/type'
import {VehicleMovementReportBase} from './VehicleMovementReport/type'
import {TripNotStartedReportBase} from './TripNotStartedReport/type'

const viewProps = Object.freeze({
  Class: {
    name: 'Class',
    primaryFieldsToLabelMap: {
      class_name: 'Class Name',
      class_status: 'Status',
      Actions: 'Actions',
    },
  },
  Division: {
    name: 'Division',
    primaryFieldsToLabelMap: {
      division_name: 'Division Name',
      division_status: 'Status',
      Actions: 'Actions',
    },
  },
  Shift: {
    name: 'Shift',
    primaryFieldsToLabelMap: {
      shift_name: 'Shift Name',
      starting_time: 'Starting Time',
      ending_time: 'End Time',
      Actions: 'Actions',
    },
  },
  Holiday: {
    name: 'Holidays',
    primaryFieldsToLabelMap: {
      holiday_date: 'Holiday Date',
      reason: 'Occasion',
      academic_year: 'Academic Year',
      Actions: 'Actions',
    },
  },
  Bus: {
    name: 'Bus',
    primaryFieldsToLabelMap: {
      bus_name: 'Bus Brand',
      bus_number: 'Bus Number',
      bus_registration_number: 'Registration Number',
      bus_seat_capacity: 'Seat Capacity',
      bus_status: 'Status',
      more: 'More Info',
      Actions: 'Actions',
    },
    secondaryFieldsToMap: {
      bus_insurance_expiry: 'Insurance Expiry',
      bus_polution_expiry: 'Pollution Expiry',
      bus_last_service: 'Last Service',
    },
  },
  BusBrand: {
    name: 'Bus Brand',
    primaryFieldsToLabelMap: {
      bus_type: 'Bus Brand',
      bus_type_status: 'Bus Brand',
      Actions: 'Actions',
    },
  },
  BusAttendees: {
    name: 'Bus Attendees',
    primaryFieldsToLabelMap: {
      conductor_name: 'Bus Attendee Name',
      mobile_display: 'Mobile',
      conductor_status: 'Status',
      more: 'More Info',
      Actions: 'Actions',
    },
    secondaryFieldsToMap: {
      conductor_name: 'Bus Attendee Name',
      conductor_mobile: 'Mobile',
      conductor_status: 'Status',
      conductor_reg_num: 'Employee ID',
      license_expiry_date: 'License Expiry Date',
      passport: 'Passport',
      passport_expiry: 'Passport Expiry',
      passport_country: 'Passport Country',
      qatar_id: 'Qatar id',
      qatar_id_expiry: 'Qatar Id Expiry',
      blood_group: 'Blood group',
    },
  },
  Security: {
    name: 'Security',
    primaryFieldsToLabelMap: {
      security_name: 'Security Name',
      security_code: 'Security Code',
      // security_reg_num: 'Regitration Number',
      security_status: 'Status',
      more: 'More Info',
      Actions: 'Actions',
    },
    secondaryFieldsToMap: {
      license_expiry_date: 'License Expiry Date',
      passport: 'Passport',
      passport_expiry: 'Passport Expiry',
      passport_country: 'Passport Country',
      qatar_id: 'Qatar id',
      qatar_id_expiry: 'Qatar Id Expiry',
      blood_group: 'Blood group',
    },
  },
  TeamLeader: {
    name: 'Team Leader',
    primaryFieldsToLabelMap: {
      name: 'Team Leader Name',
      gate_number: 'Gate Number',
      active_status: 'Status',
      Actions: 'Actions',
    },
  },
  TransportAdmin: {
    name: 'Transport Admin User',
    primaryFieldsToLabelMap: {
      name: 'Transport Admin Name',
      mobile: 'Mobile',
      // transport_admin_reg_num: 'Regitration Number',
      transport_status: 'Status',
      Actions: 'Actions',
    },
  },
  Trip: {
    name: 'Trip',
    primaryFieldsToLabelMap: {
      trip_name: 'Trip Name',
      trip_type: 'Trip Type',
      trip_status: 'Trip Status',
      more: 'More Info',
      // students: 'Students in trip',
      Actions: 'Actions',
    },
    secondaryFieldsToMap: {
      driver_name: 'Driver',
      conductor_name: 'Bus Attendee',
      shift_name: 'Shift',
      route_name: 'Route',
      // start_time: 'Start Time',
      // end_time: 'End Time',
      bus_name: 'Bus Details',
      trip_number: 'Trip Number',
      sub_school_name: 'Sub School Name'
    },
  },
  TripNumber: {
    name: 'Trip Number',
    primaryFieldsToLabelMap: {
      trip_number: 'Trip Number',
      trip_number_status: 'Trip Number',
      Actions: 'Actions',
    },
  },
  StudentsInDailyTrip: {
    name: 'Students in Trip',
    primaryFieldsToLabelMap: {
      student_name: 'Student Name',
      parent_name: 'parent name',
      roll_number: 'Roll Number',
      is_present: 'Is Present',
      location_name: 'location name',
      location_latitude: 'location latitude',
      location_longitude: 'location longitude',
      checkin_location: 'checkin location',
      checkout_location: 'checkout location',
      checkin_time: 'checkin time',
      checkout_time: 'checkout time',
      checkin_status: 'Checkin Status',
      checkout_status: 'Checkout Status',
      is_manual_checkin: 'is manual checkin',
      is_manual_checkout: 'is manual checkout',
      is_manual_markabsent: 'is manual markabsent',
      is_wrong_board: 'is wrong board',
    },
  },
  StudentsInTrip: {
    name: 'Students in Trip',
    primaryFieldsToLabelMap: {
      student_name: 'Student Name',
      regID: 'Reg. Id',
      class: 'Class',
      division: 'division',
      remove: 'Remove',
    },
  },
  Roots: {
    name: 'Routes',
    primaryFieldsToLabelMap: {
      route_name: 'Route Name',
      Actions: 'Actions',
    },
  },
  Driver: {
    name: 'Driver',
    primaryFieldsToLabelMap: {
      driver_name: 'Driver Name',
      country_code: 'Country Code',
      driver_phone: 'Driver Phone',
      driver_status: 'Driver Status',
      more: 'More Info',
      Actions: 'Actions',
    },
    secondaryFieldsToMap: {
      email: 'Email',
      country: 'Country',
      license_expiry_date: 'License Expiry Date',
      authorized_vehicle: 'Authorized Vehicle',
      passport: 'Passport',
      passport_expiry: 'Passport Expiry',
      passport_country: 'Passport Country',
      qatar_id: 'Qatar id',
      qatar_id_expiry: 'Qatar Id Expiry',
      driver_reg_num: 'driver reg num',
      gender: 'Gender',
      blood_group: 'Blood group',
      dob: 'Date of Birth',
      whatsapp: 'Whatsapp',
    },
  },
  Staff: {
    name: 'Staff',
    primaryFieldsToLabelMap: {
      staff_name: 'Staff Name',
      country_code: 'Country Code',
      staff_mobile: 'Staff Phone',
      staff_email: 'Staff Email',
      staff_status: 'Staff Status',
      more: 'More Info',
      Actions: 'Actions',
    },
    secondaryFieldsToMap: {      
      country: 'Country',
      license_expiry_date: 'License Expiry Date',      
      passport: 'Passport',
      passport_expiry: 'Passport Expiry',
      passport_country: 'Passport Country',
      qatar_id: 'Qatar id',
      qatar_id_expiry: 'Qatar Id Expiry',
      staff_reg_num: 'Staff reg num',
      gender: 'Gender',
      blood_group: 'Blood group',
      dob: 'Date of Birth',
      whatsapp: 'Whatsapp',
    },
  },
  Student: {
    name: 'Student',
    primaryFieldsToLabelMap: {
      student_name: 'Student Name',
      regID: 'Registration ID',
      class: 'Class',
      division: 'Division',
      shift_name: 'Shift Name',
      student_status: 'Status',
      more: 'More Info',
      Actions: 'Actions',
    },
    secondaryFieldsToMap: {
      roll_number: 'Seat Number',
      gender: 'Gender',
      dob: 'Date of Birth',
      sub_school_name: 'Sub School Name',

    },
  },
  Guardian: {
    name: 'Guardians',
    primaryFieldsToLabelMap: {
      parent_name: 'Parent Name',
      parent_mobile: 'Mobile',
      parent_email: 'Email',
      parent_user_status: 'Status',
      more: 'More Info',
      Actions: 'Actions',
    },
    secondaryFieldsToMap: {
      parent_email: 'Email',
      parent_address: 'Address',
      parent_country: 'Country',
      parent_dob: 'DOB',
      parent_gender: 'Gender',
    },
  },
  InspectionReport: {
    name: 'Inspection Report',
    primaryFieldsToLabelMap: {
      date: 'Date',
      trip_number: 'Bus No',
      inspectedByConductor: 'Conductor Name with Signature',
      inspectedByTeamLeader: 'Team Leader Name with Signature',
      inspectedBySecurity: 'Security Name with Signature',
      inspectedByDriver: 'Driver Name with Signature',
    } as Record<keyof InspectionReportBase, string>,
  },
  StudentAttendanceReport: {
    name: 'Student Attendance Report',
    primaryFieldsToLabelMap: {
      student_name: 'Student Name',
      reg_id: 'Registration ID',
      class: 'Grade',
      division: 'Division',
      date: 'Attendance Date',
      daily_bus_trip_type: 'Bus Trip Type (Pickup or Drop)',
      trip_number: 'Bus Trip Number',
    } as Record<keyof StudentAttendanceReportBase, string>,
  },
  FleetReport: {
    name: 'Fleet Report',
    primaryFieldsToLabelMap: {
      trip_number: 'Trip Number',      
      bus_brand: 'Bus Brand',      
      vehicle_number: 'Vehicle Number',
      bus_registration_number: 'Reg. Number',
      driver_name:'Driver Name',      
      driver_mobile: 'Driver Mobile',
      conductor_name:'Conductor Name', 
      conductor_mobile: 'Conductor Mobile'
      
    } as Record<keyof FleetReportBase, string>,
  },
  DriverLicenseStatus: {
    name: 'Driver License Status Report',
    primaryFieldsToLabelMap: {
      sl_no: 'SL NO',
      driver_name: 'Driver Name',
      driver_phone: 'Driver Phone',
      license_expiry_date: 'License Expiry Date',
      license_status: 'License Status',
    } as Record<keyof DriverLicenseStatusReportBase, string>,
  },
  Banner: {
    banner_name: 'Banner',
    primaryFieldsToLabelMap: {
      banner_name: 'Banner Name', 
      banner_image: 'Banner File',     
      banner_status: 'Banner Status',
      Actions: 'Actions',
    },
  },
  RouteReport: {
    name: 'Route Chart Report',
    primaryFieldsToLabelMap: {
      bus_no: 'Bus No.',
      seating_capacity: 'Seating Capacity',
    zone_street_buildings: 'Area/Route',
    boys_girls: 'Boys/Girls',
    driver_name: 'Driver Name',
    student_enrolled: 'Student Enrolled',
    staff_enrolled: 'Staff Enrolled',
    total: 'Total',
    collect_time: 'Collecting Time Of First Student'     
    } as Record<keyof RouteReportBase, string>,

    // 👇 Add this block
    columnWidths: {
    zone_street_buildings: 400,   // width in pixels
  },
  },
  DriverLoginReport: {
    name: 'Driver Login Report',
    primaryFieldsToLabelMap: {
      trip_bus: "Tip number / Bus No",
      dated_on: "Trip Date",
      driver_name: "Driver Name",
      shift_name: "Shift Name",
      trip_type: "Trip Type",
      login_time: "Login Time",      
      logout_time: "Logout Time",
         
    } as Record<keyof DriverLoginReportBase, string>,  
    
  },
  VehicleMovementReport: {
    name: 'Daily Vehicle Movement Report',
    primaryFieldsToLabelMap: {
      trip_bus: "Bus No",     
      driver_name: "Driver Name",
      conductor_name:"Conductor Name",           
      trip_out: "Out", 
      checked_in: "Checked In", 
      sign:"Driver",
      status:"Remark",
         
    } as Record<keyof VehicleMovementReportBase, string>,  
    
  },
  TripNotStartedReport: {
    name: 'Trip Not Started Report',
    primaryFieldsToLabelMap: {
      trip_type: "Trip Type",
      shift_name: "Shift Name",
      trip_name: "Trip Name",
      sub_school_name:"Sub School Name",
      trip_start_time:"Trip Start Time",
      trip_end_time:"Trip End Time",
      bus_number:"Bus Number",
      bus_registration_number:"Bus Registration Number",
      conductor_name:"Conductor Name",
      conductor_mobile:"Conductor Mobile",
      driver_name:"Driver Name",
      driver_mobile:"Driver Mobile" 
         
    } as Record<keyof TripNotStartedReportBase, string>,  
    
  },

})
export default viewProps
